import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';
import { FocusboxItemValue } from '../../../shared-models';
import { WrittenContentLinkActionsUnion } from '../../listeners/written-content-anchor-click-listener';

@Component({
  selector: 'grid-ui-body-item-focusbox',
  templateUrl: './body-item-focusbox.component.html',
  styleUrls: ['./body-item-focusbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'FocusBox',
  },
  standalone: false,
})
export class BodyItemFocusboxComponent {
  public readonly value = input.required<FocusboxItemValue>();

  public readonly writtenContentLinkAction = output<WrittenContentLinkActionsUnion>();
}
